// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file host_config/host_config_response.proto (package com.gem.bff.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

/**
 * Describes the file host_config/host_config_response.proto.
 */
export const file_host_config_host_config_response: GenFile =
  /*@__PURE__*/
  fileDesc(
    'CiZob3N0X2NvbmZpZy9ob3N0X2NvbmZpZ19yZXNwb25zZS5wcm90bxIUY29tLmdlbS5iZmYuY29udHJhY3QiYgoYQmZmR2V0SG9zdENvbmZpZ1Jlc3BvbnNlEj4KB3N1Y2Nlc3MYASABKAsyKy5jb20uZ2VtLmJmZi5jb250cmFjdC5CZmZIb3N0Q29uZmlnUmVzcG9uc2VIAEIGCgR0eXBlIrMBChVCZmZIb3N0Q29uZmlnUmVzcG9uc2USEQoJaG9zdF9uYW1lGAEgASgJEhUKDWhvc3RfcmVzdF91cmwYAiABKAkSFwoPaG9zdF9zb2NrZXRfdXJsGAMgASgJEhwKFGhvc3RfY2FsbF9zb2NrZXRfdXJsGAQgASgJEiIKGmhvc3RfdW5hdXRob3JpemVkX2NhbGxfdXJsGAUgASgJEhUKDXN1cHBvcnRfZW1haWwYBiABKAkiggEKKEJmZkdldFVuYXV0aG9yaXplZENhbGxIb3N0Q29uZmlnUmVzcG9uc2USTgoHc3VjY2VzcxgBIAEoCzI7LmNvbS5nZW0uYmZmLmNvbnRyYWN0LkJmZlVuYXV0aG9yaXplZENhbGxIb3N0Q29uZmlnUmVzcG9uc2VIAEIGCgR0eXBlImkKJUJmZlVuYXV0aG9yaXplZENhbGxIb3N0Q29uZmlnUmVzcG9uc2USHAoUaG9zdF9jYWxsX3NvY2tldF91cmwYASABKAkSIgoaaG9zdF91bmF1dGhvcml6ZWRfY2FsbF91cmwYAiABKAlCGAoUY29tLmdlbS5iZmYuY29udHJhY3RQAWIGcHJvdG8z'
  );

/**
 * @generated from message com.gem.bff.contract.BffGetHostConfigResponse
 */
export type BffGetHostConfigResponse = Message<'com.gem.bff.contract.BffGetHostConfigResponse'> & {
  /**
   * @generated from oneof com.gem.bff.contract.BffGetHostConfigResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.BffHostConfigResponse success = 1;
         */
        value: BffHostConfigResponse;
        case: 'success';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.BffGetHostConfigResponse.
 * Use `create(BffGetHostConfigResponseSchema)` to create a new message.
 */
export const BffGetHostConfigResponseSchema: GenMessage<BffGetHostConfigResponse> =
  /*@__PURE__*/
  messageDesc(file_host_config_host_config_response, 0);

/**
 * @generated from message com.gem.bff.contract.BffHostConfigResponse
 */
export type BffHostConfigResponse = Message<'com.gem.bff.contract.BffHostConfigResponse'> & {
  /**
   * @generated from field: string host_name = 1;
   */
  hostName: string;

  /**
   * @generated from field: string host_rest_url = 2;
   */
  hostRestUrl: string;

  /**
   * @generated from field: string host_socket_url = 3;
   */
  hostSocketUrl: string;

  /**
   * @generated from field: string host_call_socket_url = 4;
   */
  hostCallSocketUrl: string;

  /**
   * @generated from field: string host_unauthorized_call_url = 5;
   */
  hostUnauthorizedCallUrl: string;

  /**
   * @generated from field: string support_email = 6;
   */
  supportEmail: string;
};

/**
 * Describes the message com.gem.bff.contract.BffHostConfigResponse.
 * Use `create(BffHostConfigResponseSchema)` to create a new message.
 */
export const BffHostConfigResponseSchema: GenMessage<BffHostConfigResponse> =
  /*@__PURE__*/
  messageDesc(file_host_config_host_config_response, 1);

/**
 * @generated from message com.gem.bff.contract.BffGetUnauthorizedCallHostConfigResponse
 */
export type BffGetUnauthorizedCallHostConfigResponse =
  Message<'com.gem.bff.contract.BffGetUnauthorizedCallHostConfigResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.BffGetUnauthorizedCallHostConfigResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.BffUnauthorizedCallHostConfigResponse success = 1;
           */
          value: BffUnauthorizedCallHostConfigResponse;
          case: 'success';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.BffGetUnauthorizedCallHostConfigResponse.
 * Use `create(BffGetUnauthorizedCallHostConfigResponseSchema)` to create a new message.
 */
export const BffGetUnauthorizedCallHostConfigResponseSchema: GenMessage<BffGetUnauthorizedCallHostConfigResponse> =
  /*@__PURE__*/
  messageDesc(file_host_config_host_config_response, 2);

/**
 * @generated from message com.gem.bff.contract.BffUnauthorizedCallHostConfigResponse
 */
export type BffUnauthorizedCallHostConfigResponse =
  Message<'com.gem.bff.contract.BffUnauthorizedCallHostConfigResponse'> & {
    /**
     * @generated from field: string host_call_socket_url = 1;
     */
    hostCallSocketUrl: string;

    /**
     * @generated from field: string host_unauthorized_call_url = 2;
     */
    hostUnauthorizedCallUrl: string;
  };

/**
 * Describes the message com.gem.bff.contract.BffUnauthorizedCallHostConfigResponse.
 * Use `create(BffUnauthorizedCallHostConfigResponseSchema)` to create a new message.
 */
export const BffUnauthorizedCallHostConfigResponseSchema: GenMessage<BffUnauthorizedCallHostConfigResponse> =
  /*@__PURE__*/
  messageDesc(file_host_config_host_config_response, 3);
